<template>
  <div class="block-subscribe-form py-10 lg:py-24" :class="wrapperClasses">
    <div class="mx-auto w-full max-w-screen-xl px-14 lg:px-32">
      <div class="mb-4 text-center text-2xl font-bold lg:text-4xl">{{ title }}</div>
      <div class="mb-8 text-center text-lg font-bold">{{ subtitle }}</div>
      <VcInput class="mx-auto max-w-lg" :placeholder="placeholder" />

      <div class="text-center">
        <div class="checkbox-text mt-4">
          <VcCheckbox class="inline-flex">
            <span v-html-safe="checkboxText" class="checkbox-label"></span>
          </VcCheckbox>
        </div>

        <VcButton class="mt-10">
          {{ buttonText }}
        </VcButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  title?: string;
  subtitle?: string;
  placeholder?: string;
  checkboxText?: string;
  buttonText?: string;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)",
    "block-subscribe-form py-10 lg:py-24",
  ];
});
</script>

<style lang="scss">
.block-subscribe-form {
  .checkbox-label a {
    @apply text-[--link-color] hover:text-[--link-hover-color];
  }

  &.bg-neutral-800 {
    .title,
    .subtitle,
    .checkbox-text {
      color: white;
    }
  }
}
</style>
